import { render, staticRenderFns } from "./PackagePayments.vue?vue&type=template&id=a76da6ba&scoped=true"
import script from "./PackagePayments.vue?vue&type=script&lang=js"
export * from "./PackagePayments.vue?vue&type=script&lang=js"
import style0 from "./PackagePayments.vue?vue&type=style&index=0&id=a76da6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76da6ba",
  null
  
)

export default component.exports